var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-chart",style:({ height: _vm.height })},[(_vm.showGradient)?_c('div',{staticClass:"chart-gradient"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }